import React from "react";
import { FaPaypal, FaMoneyBillWave, FaCoins } from "react-icons/fa";

function Donate() {
  return (
    <section style={styles.container}>
      <h1>Support Our Mission</h1>

      <img
        src="https://images.unsplash.com/photo-1601597111158-2fceff292cdc?w=600&auto=format&fit=crop&q=60"
        alt="donation"
        style={styles.image}
        loading="lazy"
      />

      <p>Your donations help us reach more lives and create impact.</p>

      <div style={styles.options}>
        <a href="https://www.paypal.com/donate/YOUR_PAYPAL_LINK" target="_blank" rel="noreferrer">
          <button style={styles.btn}><FaPaypal style={{ marginRight: "5px" }} /> Donate with PayPal-(COMING SOON)</button>
        </a>

        <a href="YOUR_POUNDS_PAYMENT_LINK" target="_blank" rel="noreferrer">
          <button style={styles.btn}><FaMoneyBillWave style={{ marginRight: "5px" }} /> Donate in Pounds-(COMING SOON) (£)</button>
        </a>

        <a href="YOUR_NAIRA_PAYMENT_LINK" target="_blank" rel="noreferrer">
          <button style={styles.btn}><FaCoins style={{ marginRight: "5px" }} /> Donate in Naira-(COMING SOON) (₦)</button>
        </a>
      </div>
    </section>
  );
}

const styles = {
  container: {
    textAlign: "center",
    padding: "80px 20px"
  },
  image: {
    width: "100%",
    maxWidth: "500px",
    borderRadius: "10px",
    margin: "20px 0"
  },
  options: {
    display: "flex",
    gap: "20px",
    justifyContent: "center",
    flexWrap: "wrap",
    marginTop: "30px"
  },
  btn: {
    padding: "12px 20px",
    background: "#ca9462",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "transform 0.3s, background 0.3s"
  }
};

export default Donate;